module.exports = __webpack_public_path__ + "img/734-f873bf.png";